import { KeywordPerformanceScores } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/ContentServerProxy/types';
import { ChartDataAdapter } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/adapters/types';
import {
  KeywordFilter,
  KeywordPerformanceGaugeData
} from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/types';

export class KeywordsPerformanceSummaryAdapter implements ChartDataAdapter<KeywordPerformanceGaugeData> {
  mainScores: KeywordPerformanceScores;

  comparisonScores: KeywordPerformanceScores;

  constructor(mainScores: KeywordPerformanceScores, comparisonScores: KeywordPerformanceScores) {
    this.mainScores = mainScores;
    this.comparisonScores = comparisonScores;
  }

  transform(): KeywordPerformanceGaugeData {
    const gaugeData: KeywordPerformanceGaugeData = [
      {
        title: 'Keyword Usage',
        percentage: this.mainScores.keywordUsageScore,
        change: this.mainScores.keywordUsageScore - this.comparisonScores.keywordUsageScore,
        value: this.mainScores.averageCountOfKeywords,
        filterKey: KeywordFilter.Usage
      },
      {
        title: 'Keyword Productivity',
        percentage: this.mainScores.keywordProductivityScore,
        change: this.mainScores.keywordProductivityScore - this.comparisonScores.keywordProductivityScore,
        value: this.mainScores.averageCountOfKeywordsGeneratingTraffic,
        filterKey: KeywordFilter.Productivity
      },
      {
        title: 'Keyword Popularity',
        percentage: this.mainScores.keywordPopularityScore,
        change: this.mainScores.keywordPopularityScore - this.comparisonScores.keywordPopularityScore,
        value: this.mainScores.averageVolumeOfSearchTraffic,
        filterKey: KeywordFilter.Popularity
      }
    ];

    return gaugeData;
  }
}
